import React from 'react';
import { useFilterContributions } from '../../../../hooks/useFilterContributions';
import { STATUS_MAP, SALES_CHANNEL_MAP, ORDER_TYPE_MAP } from './consts';
import { OrdersFilterView } from './OrdersFilterView';
const mapEntriesToOptions = ([value, label]) => ({ value, label });
export const OrdersFilterContainer = () => {
    const { filtersParams, setFiltersParams, resetFiltersParams, hasFilterParams } = useFilterContributions();
    const handleSubmit = (values) => {
        setFiltersParams({
            status: values.status.length ? values.status.join(',') : undefined,
            salesChannel: values.salesChannel.length ? values.salesChannel.join(',') : undefined,
            type: values.type.length ? values.type.join(',') : undefined,
        });
    };
    return (React.createElement(OrdersFilterView, { initialValues: {
            status: filtersParams.status ? filtersParams.status.split(',') : [],
            salesChannel: filtersParams.salesChannel ? filtersParams.salesChannel.split(',') : [],
            type: filtersParams.type ? filtersParams.type.split(',') : [],
        }, statuses: Object.entries(STATUS_MAP).map(mapEntriesToOptions), salesChannels: Object.entries(SALES_CHANNEL_MAP).map(mapEntriesToOptions), types: Object.entries(ORDER_TYPE_MAP).map(mapEntriesToOptions), filterActive: hasFilterParams, onSubmit: handleSubmit, onReset: resetFiltersParams }));
};
